/**
 * TODO: Доработать в рамках https://sravni-corp.atlassian.net/browse/CF-3559
 */
export const prodMock = [
  {
    label: 'Срок',
    alias: 'sub-creditObtainingMethod',
    webType: 'Select',
    fields: [
      {
        name: 'Наличными',
        value: 'cash',
      },
    ],
    selectedValue: null,
  },
  {
    label: 'Без поручителей',
    alias: 'sub-guarantorFilter',
    webType: 'Select',
    fields: [
      {
        name: 'Без поручителей',
        value: 'noGuarantor',
      },
    ],
    selectedValue: null,
  },
  {
    label: 'Без справок',
    alias: 'sub-solvencyProof',
    webType: 'Select',
    fields: [
      {
        name: 'Без справок',
        value: 'without-income-references',
      },
    ],
    selectedValue: null,
  },
  {
    label: 'С любой кредитной историей',
    alias: 'sub-demands',
    webType: 'Select',
    fields: [
      {
        name: 'С любой кредитной историей',
        value: 'positive-credit-history',
      },
    ],
    selectedValue: null,
  },
  {
    label: 'Сумма',
    alias: 'amount',
    webType: 'Input',
    fields: [],
    selectedValue: null,
  },
  {
    label: 'Срок',
    alias: 'period',
    webType: 'Input',
    fields: [],
    selectedValue: null,
  },
];
